import { useEffect, useState } from "react"
import useDataPolicy from "./useDataPolicy"

const UseChecksPolicy = (isPoints = false, checksPolicyData) => {
  // Valida la cantidad de checks en true para uso en formularios con useState

  const [checks, setChecks] = useState([])
  const { checksPolicy } = useDataPolicy()
  const checksPolicyFinal = checksPolicyData || checksPolicy

  // crear array con la cantidad de checks, si no hay check puntos por defecto esta en true
  useEffect(() => {
    const data = []
    checksPolicyFinal.forEach(item => {
      if (item.idPrincipal === "pbAccepted" && isPoints) {
        data.push(false)
      } else if (item.idPrincipal === "pbAccepted" && !isPoints) {
        data.push(true)
      } else if (item.idPrincipal !== "pbAccepted") {
        data.push(false)
      }
    })
    setChecks(data)
  }, [])

  // cambia el check a true o false si esta o no seleccionado
  const changeCheck = (index, state) => {
    const newData = checks.map((item, i) => {
      if (i === index) {
        return state
      } else {
        return item
      }
    })
    setChecks(newData)
  }

  // valida si todos los checks estan en ok
  const isAllChecksTrue = () => {
    return checks.some(item => item === false)
  }

  const getPayloadCheck = () => {
    return checksPolicyFinal.reduce((acc, { idPrincipal }) => {
      if (idPrincipal === "pbAccepted" && isPoints) {
        acc[idPrincipal] = 1
      } else if (idPrincipal !== "pbAccepted") {
        acc[idPrincipal] = 1
      }
      return acc
    }, {})
  }

  return {
    checks,
    changeCheck,
    isAllChecksTrue,
    getPayloadCheck,
  }
}

export default UseChecksPolicy
